import { render, staticRenderFns } from "./dputr_bangunan.vue?vue&type=template&id=37cf08f6&"
import script from "./dputr_bangunan.vue?vue&type=script&lang=js&"
export * from "./dputr_bangunan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QDialog,QIcon,QPopupProxy,QDate,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QDialog,QIcon,QPopupProxy,QDate,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
